/** @jsxImportSource @emotion/react */
"use client";
import { forwardRef } from "react";

import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { WithAsChild } from "../../../../types/withAsChild.types";
import { determineElementFromAsChild } from "../../../../utils/determineElementFromAsChild";

const hallowElement: HallowElement = "li";

export type ListItemProps = WithAsChild<
  HallowElementProps<typeof hallowElement>
>;

export const ListItem = forwardRef<any, ListItemProps>(
  ({ asChild = false, children, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement ref={ref} {...props}>
        {children}
      </DeterminedElement>
    );
  },
);

ListItem.displayName = "ListItem";
